import React from 'react';
import { Popover } from '@mui/material';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';

interface EmojiPickerPopoverProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onEmojiSelect: (emoji: any) => void;
}

const EmojiPickerPopover = ({ anchorEl, onClose, onEmojiSelect }: EmojiPickerPopoverProps) => (
  <Popover
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    slotProps={{
      paper: {
        sx: {
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          overflow: 'visible',
        },
      },
    }}
  >
    <Picker
      data={data}
      onEmojiSelect={(emoji: any) => {
        onEmojiSelect(emoji);
        onClose();
      }}
      previewPosition='bottom'
      skinTonePosition='preview'
      theme='light'
      set='native'
      autoFocus
    />
  </Popover>
);

export default EmojiPickerPopover;
